<div [ngStyle]="{ 'display': (hidden) ? 'none': 'inherit' }" class="screen-only">
	<ng-template #toolbarHost></ng-template>
	@if (gridOptions != null) {
		<ag-grid-angular class="data-grid " [rowData]="data$ | async"
					 [columnDefs]="gridCols"
					 [gridOptions]="gridOptions" [attr.aria-label]="ariaLabel"></ag-grid-angular>	
	}
	
</div>
